
//Représente les paramètres de mise à jour du statut des factures d’achat
export class AeFMettreAJourStatutFacturesAchatParametres 
{
  //Identifiant de la session
  public identifiantSession!: string;

  //Identifiants des factures
  public identifiantsFactures!: string[];

  //Identifiant du statut transmis
  public identifiantStatutTransmis!: string;

  //Code du statut
  public codeStatut!: string;

  //Code du motif
  public codeMotif!: string | null;

  //Note
  public note!: string | null;
}
